import React from "react";
import useTranslation from "next-translate/useTranslation";
import Page from "@/components/layout/page";
import styles from "./Leagues.module.css";
import { FaTrophy } from "react-icons/fa";
import LeaguesHeader from "./LeaguesHeader";
import LeaguesBody from "./LeaguesBody";
// import { useRouter } from "next/router";
import Head from "next/head";

const Leagues = ({ modeId }) => {
  const { t } = useTranslation("common");
  // const router = useRouter();
  // const { modeId } = router.query;
  const activeMove = modeId && Number(modeId);

  return (
    <Page title={t("League tables")} icon={<FaTrophy />}>
      <Head>
        <title>Chess Hotel | {t("League tables")}</title>
        <meta name="description" content={t("description")} />
        <meta name="keywords" content={t("keywords")} />
      </Head>
      <div className={styles.wrapper}>
        <LeaguesHeader activeMode={activeMove} />
        <LeaguesBody activeMode={activeMove} />
      </div>
    </Page>
  );
};

export default Leagues;
